import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RequireAuth } from "@components/auth/RequireAuth";
import { RiderLayout } from "@components/layout/RiderLayout";

const Home = React.lazy(() => import("@pages/Home").then((m) => ({ default: m.Home })));
const Login = React.lazy(() => import("@pages/Login").then((m) => ({ default: m.Login })));
const ForgotPassword = React.lazy(() =>
    import("@pages/ForgotPassword").then((m) => ({ default: m.ForgotPassword }))
);
const Otp = React.lazy(() => import("@pages/Otp").then((m) => ({ default: m.Otp })));
const ResetPassword = React.lazy(() =>
    import("@pages/ResetPassword").then((m) => ({ default: m.ResetPassword }))
);
const Customers = React.lazy(() =>
    import("@pages/Customers").then((m) => ({ default: m.Customers }))
);
const CustomerDetail = React.lazy(() =>
    import("@pages/CustomerDetail").then((m) => ({ default: m.CustomerDetail }))
);
const SyncStatus = React.lazy(() =>
    import("@pages/SyncStatus").then((m) => ({ default: m.SyncStatus }))
);
const Settings = React.lazy(() => import("@pages/Settings").then((m) => ({ default: m.Settings })));
const Notifications = React.lazy(() =>
    import("@pages/Notifications").then((m) => ({ default: m.Notifications }))
);

const RouteFallback: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className="flex min-h-screen items-center justify-center text-neutral-secondary">
            {t("common.loading")}
        </div>
    );
};

export const Router: React.FC = () => (
    <Suspense fallback={<RouteFallback />}>
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/otp" element={<Otp />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route
                element={
                    <RequireAuth>
                        <RiderLayout />
                    </RequireAuth>
                }
            >
                <Route path="/" element={<Home />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/customers/:id" element={<CustomerDetail />} />
                <Route path="/sync" element={<SyncStatus />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/notifications" element={<Notifications />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    </Suspense>
);
